import { Link, useLocation } from "react-router-dom";
import React, { useState, } from "react";
import logo from "../assets/tekpossible-logo.svg";
import Logo1 from "../assets/logov2.svg"
import { MenuIcon, XIcon, ChevronDownIcon } from "@heroicons/react/outline";
import "../component/Navbar.css";

const Navbar = () => {
    const location = useLocation();
    const [hoveredHome, setHoveredHome] = useState(false);
    const [hoveredService, setHoveredService] = useState(false);
    const [hoveredSolution, setHoveredSolution] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showProductOptions, setShowProductOptions] = useState(false);
    const [showServiceOptions, setShowServiceOptions] = useState(false);
    const [showSolutionOptions, setShowSolutionOptions] = useState(false);
    const [showHomeOptions, setShowHomeOptions] = useState(false);

    const handleHomeHover = () => {
        setHoveredHome(true);
    };

    const handleHomeLeave = () => {
        setHoveredHome(false);
    };

    const handleServiceHover = () => {
        setHoveredService(true);
    };

    const handleServiceLeave = () => {
        setHoveredService(false);
    };

    const handleSolutionHover = () => {
        setHoveredSolution(true);
    };

    const handleSolutionLeave = () => {
        setHoveredSolution(false);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const toggleServiceOptions = () => {
        setShowServiceOptions(!showServiceOptions);
        if (showHomeOptions || showSolutionOptions || showProductOptions) {
            setShowHomeOptions(false);
            setShowSolutionOptions(false);
            setShowProductOptions(false);
        }
    };
    const toggleProductOptions = () => {
        setShowProductOptions(!showProductOptions);
        if (showHomeOptions || showSolutionOptions || showSolutionOptions) {
            setShowHomeOptions(false);
            setShowSolutionOptions(false);
            setShowServiceOptions(false);
        }
    };

    const toggleSolutionOptions = () => {
        setShowSolutionOptions(!showSolutionOptions);
        if (showHomeOptions || showServiceOptions || showProductOptions) {
            setShowHomeOptions(false);
            setShowServiceOptions(false);
            setShowProductOptions(false);
        }
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const showGradientDiv =
        location.pathname.startsWith("/products") ||
        location.pathname.startsWith("/services") ||
        location.pathname.startsWith("/solutions") ||
        location.pathname === "/about" ||
        location.pathname === "/contact-us" ||
        location.pathname === "/registration";

    const isHomeOrBenchtrack =
        location.pathname === "/" || location.pathname === "/benchtrack";


    return (
        <>

            {showGradientDiv && (
                <div className="bg-gradient-to-r from-[#981A59] to-[#124B6A] w-full h-3 sticky top-0 z-10"></div>
            )}
            <nav className={location.pathname === "/" || location.pathname === "/benchtrack" ? "bg-gradient-to-r from-[#981A59] to-[#124B6A] px-10 sticky top-0 z-10" : "bg-[#FFF] px-10 sticky top-0 z-10"}>
                <div className="flex items-center justify-between">
                    <div className="text-white font-bold flex items-center">
                        <Link to="/">
                            <img className="w-[150px] h-[90px]" src={location.pathname === "/" || location.pathname === "/benchtrack" ? logo : Logo1} alt="Logo" />
                        </Link>
                    </div>

                    <div className="hidden lg:flex items-center gap-10">
                        <Link
                            to="/"
                            className={`font-semibold relative inline-block ${location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : ""}`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/registration"
                            className={`font-semibold relative inline-block ${location.pathname.startsWith("/registration") || (location.pathname === "/usa-registrations") || (location.pathname === "/canada-registrations") ? (location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : "active-link1") : (location.pathname === "/" || location.pathname === "/benchtrack" ? "text-white" : "text-black")}`}
                        >
                            Register
                        </Link>
                        <div
                            onMouseEnter={handleHomeHover}
                            onMouseLeave={handleHomeLeave}
                            className="relative group"
                        >
                            <Link
                                to="/products/benchtrack"
                                className={`font-semibold relative inline-block ${location.pathname.startsWith("/products") ? (location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : "active-link1") : (location.pathname === "/" || location.pathname === "/benchtrack" ? "text-white" : "text-black")}`}
                            >
                                Products
                            </Link>
                            {hoveredHome && (
                                <div className="absolute service-1 top-full left-1/2 transform -translate-x-1/2 text-white p-3 rounded-2xl shadow-md w-64 z-10 bg-white mt-">
                                    <ul>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] whitespace-nowrap mt-3 ${location.pathname === "/products/benchtrack" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/products/benchtrack" className="hover:no-underline">Benchtrack</Link>
                                        </li>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] mt-3 whitespace-nowrap mb-3 ${location.pathname === "/products/sn-buddy" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/products/sn-buddy" className="hover:no-underline">SN Resume Buddy</Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div
                            onMouseEnter={handleServiceHover}
                            onMouseLeave={handleServiceLeave}
                            className="relative group"
                        >
                            <Link
                                to="/services/technical-consultation"
                                className={`font-semibold relative inline-block ${location.pathname.startsWith("/services") ? (location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : "active-link1") : (location.pathname === "/" || location.pathname === "/benchtrack" ? "text-white" : "text-black")}`}
                            >
                                Services
                            </Link>
                            {hoveredService && (
                                <div className="absolute service-1 top-full left-1/2 transform -translate-x-1/2 text-white p-3 rounded-2xl shadow-md w-64 z-10 bg-white mt-">
                                    <ul>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] whitespace-nowrap mt-3 ${location.pathname === "/services/technical-consultation" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/services/technical-consultation" className="hover:no-underline">Technical Consultation</Link>
                                        </li>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] mt-7 whitespace-nowrap ${location.pathname === "/services/platform-implementation" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/services/platform-implementation" className="hover:no-underline">Platform Implementation</Link>
                                        </li>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] mt-7 whitespace-nowrap ${location.pathname === "/services/servicenow-optimization" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/services/servicenow-optimization" className="hover:no-underline">Service now Optimization</Link>
                                        </li>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] mt-7 whitespace-nowrap ${location.pathname === "/services/managed-service" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/services/managed-service" className="hover:no-underline">Managed Service</Link>
                                        </li>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] mt-7 whitespace-nowrap ${location.pathname === "/services/strategic-planning" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/services/strategic-planning" className="hover:no-underline">Strategic Planning</Link>
                                        </li>
                                        <li className={`text-[#7A7979] hover:text-[#C32A7C] mt-7 whitespace-nowrap mb-4 ${location.pathname === "/services/platform-automation" ? "active-link" : ""}`}>
                                            <span className='tekp_indicators'></span>
                                            <Link to="/services/platform-automation" className="hover:no-underline">Platform Automation</Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div
                            onMouseEnter={handleSolutionHover}
                            onMouseLeave={handleSolutionLeave}
                            className="relative group"
                        >
                            <Link
                                to="/solutions/it-service"
                                className={`font-semibold relative inline-block ${location.pathname.startsWith("/solutions") ? (location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : "active-link1") : (location.pathname === "/" || location.pathname === "/benchtrack" ? "text-white" : "text-black")}`}
                            >
                                Solutions
                            </Link>
                            {hoveredSolution && (
                                <div className="service-1 absolute top-full left-1/2 transform -translate-x-1/2 text-white p-[15px] rounded-2xl shadow-md w-[620px] z-10 bg-white">
                                    <div className="grid grid-cols-2 gap-10">
                                        <div>
                                            <div>
                                                <h3 className="font-semibold text-black mb-2 whitespace-nowrap p-[15px]">IT Workflows</h3>
                                                <ul>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/it-service" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/it-service">IT service management</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/it-asset" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/it-asset">IT asset management</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/it-risk" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/it-risk">Integrated risk management</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/it-operation" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/it-operation">IT operations management</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/strategic-portfolio" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/strategic-portfolio">Strategic portfolio management</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/security-operations" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/security-operations">Security Operations</Link>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="mt-6">
                                                <h3 className="font-semibold text-black mb-2 whitespace-nowrap p-[15px]">Employee workflows</h3>
                                                <ul>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/hr-service" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/hr-service">Hr service delivery</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/workplace-service" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/workplace-service">Workplace service delivery</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div>
                                            <div>
                                                <h3 className="font-semibold text-black mb-2 whitespace-nowrap p-[15px]">Customer workflows</h3>
                                                <ul>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/customer-service" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/customer-service">Customer service management</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/field-service" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/field-service">Field service management</Link>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="mt-6">
                                                <h3 className="font-semibold text-black mb-2 whitespace-nowrap p-[15px]">Creator workflows</h3>
                                                <ul>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/app-engine" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/app-engine">App engine</Link>
                                                    </li>
                                                    <li className={`text-[#7A7979] hover:text-[#C32A7C] mb-7 whitespace-nowrap ${location.pathname === "/solutions/integration-hub" ? "active-link" : ""}`}>
                                                        <span className='tekp_indicators'></span>
                                                        <Link to="/solutions/integration-hub">Integration hub</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>


                        <Link
                            to="/about"
                            className={`font-semibold relative inline-block ${location.pathname === "/about" ? (location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : "active-link1") : (location.pathname === "/" || location.pathname === "/benchtrack" ? "text-white" : "text-black")}`}
                        >
                            About
                        </Link>

                        <Link
                            to="/contact-us"
                            className={`but1 bg-[#C32A7C] px-4 py-2 rounded-lg text-white font-semibold ml-4 hover:bg-[#FFFFFF] hover:text-[#C32A7C] transition-colors duration-300 border border-[#C32A7C]
                                ${location.pathname === "/contact-us" ? (location.pathname === "/" || location.pathname === "/benchtrack" ? "active-link" : "active-link1") : (location.pathname === "/" || location.pathname === "/benchtrack" ? "text-white" : "")}
                                `}
                        >
                            Contact Us
                        </Link>
                    </div>

                    <div className="lg:hidden">
                        <button
                            onClick={toggleMobileMenu}
                            className={`focus:outline-none flex items-center justify-center ${isHomeOrBenchtrack ? "text-white" : "text-black"}`}
                        >
                            {mobileMenuOpen ? (
                                <XIcon className="h-6 w-6" />
                            ) : (
                                <MenuIcon className="h-6 w-6" />
                            )}
                        </button>
                    </div>
                </div>


                {mobileMenuOpen && (
                    <div
                        className={`lg:hidden absolute top-full left-0 w-full ${location.pathname === "/" || location.pathname === "/benchtrack"
                            ? "bg-gradient-to-r from-[#981A59] to-[#124B6A]"
                            : "bg-white"
                            } p-4 overflow-y-auto max-h-screen`}
                    >
                        {/* Home Link */}
                        <Link
                            to="/"
                            className={`block py-2 ${location.pathname === "/" || location.pathname === "/benchtrack"
                                ? "text-white"
                                : "text-black"
                                } ${location.pathname === "/" ? "text-[#C32A7C]" : ""}`}
                            onClick={closeMobileMenu}
                        >
                            Home
                        </Link>
                        <Link
                            to="/registration"
                            className={`block py-2 ${location.pathname === "/" || location.pathname === "/benchtrack"
                                ? "text-white"
                                : "text-black"
                                } ${location.pathname === "/" ? "text-[#C32A7C]" : ""}`}
                            onClick={closeMobileMenu}
                        >
                            Register
                        </Link>
                        {/* Benchtrack Link */}
                        <div className="relative">
                            <button
                                onClick={toggleProductOptions}
                                className={`flex items-center justify-between w-full py-2 ${location.pathname === "/"
                                            ? "text-white" : location.pathname.startsWith("/products") ? "text-[#C32A7C]" : ""}`}
                            >
                                Product
                                <ChevronDownIcon
                                    className={`h-5 w-5 ${showProductOptions ? "rotate-180" : ""
                                        } transition-transform`}
                                />
                            </button>
                            {showProductOptions && (
                                <div className="pl-4">
                                    <ul>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/products/benchtrack"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link
                                                to="/products/benchtrack"
                                                onClick={closeMobileMenu}
                                            >
                                                Benchtrack
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" :location.pathname === "/products/sn-buddy"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link
                                                to="/products/sn-buddy"
                                                onClick={closeMobileMenu}
                                            >
                                                SN Resume Buddy
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        {/* Service Dropdown */}
                        <div className="relative">
                            <button
                                onClick={toggleServiceOptions}
                                className={`flex items-center justify-between w-full py-2 ${location.pathname === "/"
                                            ? "text-white" : location.pathname.startsWith("/services") ? "text-[#C32A7C]" : ""}`}
                            >
                                Service
                                <ChevronDownIcon
                                    className={`h-5 w-5 ${showServiceOptions ? "rotate-180" : ""
                                        } transition-transform`}
                                />
                            </button>
                            {showServiceOptions && (
                                <div className="pl-4">
                                    <ul>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/services/technical-consultation"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link
                                                to="/services/technical-consultation"
                                                onClick={closeMobileMenu}
                                            >
                                                Technical Consultation
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white"
                                            : location.pathname === "/services/platform-implementation"
                                            ? "text-[#C32A7C]" : "text-black" }>
                                            <Link
                                                to="/services/platform-implementation"
                                                onClick={closeMobileMenu}
                                            >
                                                Platform Implementation
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/services/servicenow-optimization"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link
                                                to="/services/servicenow-optimization"
                                                onClick={closeMobileMenu}
                                            >
                                                Service Now Optimization
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/services/managed-service"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/services/managed-service" onClick={closeMobileMenu}>
                                                Managed Service
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/services/strategic-planning"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link
                                                to="/services/strategic-planning"
                                                onClick={closeMobileMenu}
                                            >
                                                Strategic Planning
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/services/platform-automation"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link
                                                to="/services/platform-automation"
                                                onClick={closeMobileMenu}
                                            >
                                                Platform Automation
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        {/* Solution Dropdown */}
                        <div className="relative">
                            <button
                                onClick={toggleSolutionOptions}
                                className={`flex items-center justify-between w-full py-2 ${location.pathname === "/"
                                    ? "text-white"
                                    :location.pathname.startsWith("/solutions") ? "text-[#C32A7C]" : "text-black"} `}
                            >
                                Solution
                                <ChevronDownIcon
                                    className={`h-5 w-5 ${showSolutionOptions ? "rotate-180" : ""
                                        } transition-transform`}
                                />
                            </button>
                            {showSolutionOptions && (
                                <div className="pl-4 overflow-y-auto max-h-48 scrollbar-thin scrollbar-thumb-[#7A7979] scrollbar-track-gray-100">
                                    <h3 className={`font-semibold mb-2 ${location.pathname === "/"
                                    ? "text-white"
                                    : "text-black"
                                    }`}>Our Solutions</h3>
                                    <ul>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/it-service"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/it-service" onClick={closeMobileMenu}>
                                                IT Service Management
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/it-asset"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/it-asset" onClick={closeMobileMenu}>
                                                IT Asset Management
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/it-risk"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/it-risk" onClick={closeMobileMenu}>
                                                IT Risk Management
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/it-operation"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/it-operation" onClick={closeMobileMenu}>
                                                IT Operation Management
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/strategic-portfolio"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/strategic-portfolio" onClick={closeMobileMenu}>
                                                Strategic Portfolio Management
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/security-operations"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/security-operations" onClick={closeMobileMenu}>
                                                Security Operations
                                            </Link>
                                        </li>
                                        <li className={`font-semibold mt-2 mb-3 ${location.pathname === "/"
                                            ? "text-white"
                                            : "text-black"
                                            }`}>Employee Workflows</li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/hr-service"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/hr-service" onClick={closeMobileMenu}>
                                                HR Service Delivery
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/workplace-service"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/workplace-service" onClick={closeMobileMenu}>
                                                Workplace Service Delivery
                                            </Link>
                                        </li>
                                        <li className={`font-semibold mt-2 mb-3 ${location.pathname === "/"
                                            ? "text-white"
                                            : "text-black"
                                            }`}>Customer Workflows</li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/customer-service"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/customer-service" onClick={closeMobileMenu}>
                                                Customer Service Management
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/field-service"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/field-service" onClick={closeMobileMenu}>
                                                Field Service Management
                                            </Link>
                                        </li>
                                        <li className={`font-semibold mt-2 mb-3 ${location.pathname === "/"
                                            ? "text-white"
                                            : "text-black"
                                            }`}>Creator Workflows</li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/app-engine"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/app-engine" onClick={closeMobileMenu}>
                                                App Engine
                                            </Link>
                                        </li>
                                        <li className={location.pathname === "/"
                                            ? "text-white" : location.pathname === "/solutions/integration-hub"
                                            ? "text-[#C32A7C]"
                                            : "text-black"}>
                                            <Link to="/solutions/integration-hub" onClick={closeMobileMenu}>
                                                Integration Hub
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        <Link
                            to="/about"
                            className={`block py-2 ${location.pathname === "/"
                                ? "text-white"
                                : location.pathname === "/about" ? "text-[#C32A7C]" : "text-black"}`}
                            onClick={closeMobileMenu}
                        >
                            About
                        </Link>

                        <Link
                            to="/contact-us"
                            className={`block text-center px-4 py-2 rounded-lg font-bold mt-4 ${location.pathname === "/"
                                ? "bg-[#C32A7C] text-white hover:bg-white hover:text-[#C32A7C]"
                                : "bg-[#C32A7C] text-white hover:bg-white hover:text-[#C32A7C]"
                                } transition-colors duration-300`}
                            onClick={closeMobileMenu}
                        >
                            Contact Us
                        </Link>
                    </div>
                )}
            </nav>

        </>
    );
};

export default Navbar;